<template>
  <div class="assign-to">
    <b-form-input
      v-model="assignToSelected"
      class="email-response__assign-to"
      list="users"
      placeholder="Not Assigned"
      aria-label="user"
      autocomplete="off"
      @change="assignSelected($event)"
      :disabled="fieldDisabled"
    ></b-form-input>
    <datalist id="users">
      <option v-for="user in users" :key="user.id">
        {{ user.username }}
      </option>
    </datalist>
  </div>
</template>
<script>
export default {
  name: "AssignTo",
  props: {
    rowInfo: Object,
    availableUsers: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      users: null,
      assignToSelected: null,
      fieldDisabled: false
    };
  },
  created() {
    if (this.rowInfo.assigned_to) {
      this.assignToSelected = this.rowInfo.assigned_to;
    }
    this.users = this.availableUsers.data;
    this.disableByAssigned();
  },
  methods: {
    async assignSelected() {
      let info = {};
      info.messageId = this.rowInfo.id;
      info.body = {};
      let updateAssignment = false;
      for (let user of this.users) {
        if (this.assignToSelected == user.username) {
          updateAssignment = true;
          if (
            this.rowInfo.message_alert &&
            (this.$route.path == "/alerts" ||
              (this.$route.path == "/queue" && this.rowInfo.superuser_role))
          ) {
            info.body.post_quotation_sent_id = user.id;
          } else {
            info.body.user_id = user.id;
          }
        }
      }
      if (this.$route.path == "/alerts") {
        info.body.charlie_status = 2;
        info.body.not_quote = false;
      }
      if (updateAssignment) {
        let response = await this.$store.dispatch("quotes/updateMessage", info);
        if (response.status == 200) {
          this.fieldDisabled = true;
        }
        this.$emit("assignToSelected");
      }
    },
    disableByAssigned() {
      if (
        this.rowInfo.assigned_to === null ||
        this.rowInfo.superuser_role == true
      ) {
        this.fieldDisabled = false;
      } else {
        this.fieldDisabled = true;
      }
    }
  }
};
</script>
